import { render, staticRenderFns } from "./BaseFormItem.vue?vue&type=template&id=11bb9b27&"
import script from "./BaseFormItem.vue?vue&type=script&lang=ts&"
export * from "./BaseFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports